export default __webpack_public_path__ + "static/media/logo_white.9028d7c4.svg";